"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reverseList = function (list) { return list.map(function (item, i, l) { return l[l.length - (i + 1)]; }); };
exports.default = reverseList;
//# sourceMappingURL=reverseList.js.map